import { getParts } from "../components/kanban/components/form/utils/part-list";
import { MaintenancePart } from "../models/checkup";
import ApiService from "../services/api";

export const fetchParts = async (searchTerm?: string): Promise<MaintenancePart[]> => {
  // TODO: remove this once the API is ready
  const parts = getParts(searchTerm ?? "").map((part) => ({
    code: part.code,
    model: part.code,
    description: part.name,
  }));
  if(parts.length) return parts;
  return [{ code: searchTerm ?? "", model: searchTerm ?? "", description: searchTerm ?? "" }];

  const apiService = new ApiService(import.meta.env.VITE_MARKETPLACE_API_URL);

  try {
    const response = await apiService.get<{ content: any[] }>(`payment-gateway/backoffice/products`, { params: { page: 0, size: 20, searchTerm, type: "PART", isActive: true } });
    if (response.status === 200) {
      return (response.data?.content ?? [])
        .filter((part: any) => part.code)
        .map((part: any) => ({
          code: part.code,
          model: part.sku,
          description: part.name,
        }));
    } else {
      return [];
    }
  } catch (error: any) {
    console.error(error);
    return [];
  }
}